module.exports = {
	"ha": "vcha",
	"id": 3.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 870,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 170,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 3.5</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Vancouver Coastal Health by HSDA <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019",
					"2019",
					"2019",
					"2019",
					"2020",
					"2020",
					"2020",
					"2020",
					"2021",
					"2021",
					"2021",
					"2021",
					"2022",
					"2022"
				],
				"tickPositions": [
					0,
					2,
					6,
					10,
					14,
					18
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "North Shore / Coast Garibaldi",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					0,
					0,
					4,
					1,
					2,
					3,
					0,
					0,
					1,
					2,
					1,
					1,
					1,
					1,
					6,
					1,
					1,
					1,
					1,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Shore / Coast Garibaldi</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Richmond",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 10,
				"data": [
					0,
					1,
					0,
					0,
					2,
					2,
					1,
					1,
					2,
					2,
					2,
					2,
					2,
					0,
					0,
					1,
					0,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Richmond</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Vancouver",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 20,
				"data": [
					26,
					16,
					26,
					15,
					16,
					16,
					13,
					21,
					22,
					18,
					23,
					10,
					16,
					8,
					19,
					9,
					22,
					18,
					8,
					{
						"y": 18,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "ShortDash",
				"index": 1,
				"data": [
					2,
					0,
					3,
					0,
					1,
					3,
					1,
					0,
					2,
					2,
					1,
					1,
					0,
					1,
					3,
					1,
					0,
					1,
					0,
					0
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "ShortDash",
				"index": 11,
				"data": [
					0,
					1,
					0,
					0,
					1,
					1,
					1,
					1,
					1,
					3,
					1,
					1,
					2,
					1,
					1,
					2,
					1,
					1,
					0,
					0
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "ShortDash",
				"index": 21,
				"data": [
					25,
					17,
					34,
					22,
					21,
					25,
					15,
					23,
					30,
					19,
					27,
					11,
					21,
					11,
					24,
					8,
					25,
					20,
					12,
					24
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_3_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_3_5.json
// module id = 297
// module chunks = 0